import React, { useState } from 'react';
import { isOtherStoriesBrand } from "@pb/utils/brandConfig";
import { isArketBrand } from "@pb/utils/brandConfig";
import { isCosBrand } from "@pb/utils/brandConfig";
import cn from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import ProgressBar from "../ProgressBar";
import BodyText from "../Typography/texts/BodyText";
import MetaText from "../Typography/texts/MetaText";
import styles from './ReviewAnswer.module.scss';
const ReviewAnswer = ({ id, scale, handleSelectScale = undefined, handleClickOnTitle = undefined, progressBarWrapperClassName, progressBarClassName, progressBarBulletClassName, progressBarLabelClassName, progressBarListItemClassName, reviewCountClassName, reviews, reviewsLabel, showReviewsLabel = false, progressBarThickness = 'small', selectedDimensionValue = '', }) => {
    var _a;
    const [percentage, setPercentage] = useState(scale.percentage);
    const uniqueId = `${id}-${uuidv4()}`;
    const clickOnScale = (index, value) => {
        if (handleSelectScale) {
            setPercentage(index === 0 ? 0 : index === 1 ? 50 : 100);
            handleSelectScale(id, value);
        }
    };
    if (!scale.label || !scale.values[0] || !((_a = scale.values[0]) === null || _a === void 0 ? void 0 : _a.length)) {
        return null;
    }
    const getProgressBarLabel = () => {
        switch (true) {
            case isOtherStoriesBrand:
                return (React.createElement(BodyText, { meta: true, Tag: "span", className: cn([
                        styles.centerAligned,
                        styles.uppercase,
                        handleClickOnTitle && styles.HasHoverStyle,
                    ]), onClick: handleClickOnTitle }, scale.label));
            case isArketBrand && showReviewsLabel:
                return (React.createElement(React.Fragment, null,
                    React.createElement(BodyText, { Tag: "span" }, `${scale.label} `),
                    React.createElement(BodyText, { Tag: "span", className: cn([handleClickOnTitle && styles.HasHoverStyle], reviewCountClassName), onClick: handleClickOnTitle }, `(${reviews} ${reviewsLabel})`)));
            case isCosBrand:
                return (React.createElement(React.Fragment, null,
                    React.createElement(MetaText, { className: styles.uppercase }, scale.label),
                    React.createElement(MetaText, null,
                        ": ",
                        selectedDimensionValue || scale.values[1])));
            default:
                return scale.label;
        }
    };
    const progressBarLabel = getProgressBarLabel();
    return (React.createElement(React.Fragment, null,
        React.createElement(ProgressBar, { id: uniqueId, progressBarStartBullet: false, progressBarWrapperClassName: progressBarWrapperClassName, progressBarClassName: progressBarClassName, progressBarBulletClassName: progressBarBulletClassName, progressBarLabelClassName: progressBarLabelClassName, showPercentageBullet: true, percentage: percentage, thickness: progressBarThickness, progressBarLabel: progressBarLabel, bulletSize: isArketBrand ? 'normal' : 'large', className: cn(styles.progressBar, styles.withInitialPosition), hasVisibleProgressBar: false }),
        React.createElement("ul", { className: cn(styles.reviewScale, progressBarListItemClassName) },
            React.createElement(BodyText, { meta: true, Tag: "li", onClick: () => {
                    clickOnScale(0, scale.values[0]);
                } }, scale.values[0]),
            React.createElement(BodyText, { meta: true, Tag: "li", onClick: () => {
                    clickOnScale(1, scale.values[1]);
                } }, scale.values[1]),
            React.createElement(BodyText, { meta: true, Tag: "li", onClick: () => {
                    clickOnScale(2, scale.values[2]);
                } }, scale.values[2]))));
};
export default ReviewAnswer;
//# sourceMappingURL=ReviewAnswer.js.map